import { getUniqueMaterials } from '../../../../helpers/get-unique-material-types'
import type CalculationPosition from '../../../../types/api/calculation-position'
import CorrectMaterialCost from '../../components/calculation-form/components/form-items/correct-material-cost'
import CorrectMaterialCostNames from '../../components/calculation-form/components/other/correct-material-cost-names'
import { onAnyStandardCell, renderCalcPos } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const correctMaterialCostColumn: CalculationColumn = {
    dataIndex: 'correctMaterialCost',
    title: 'Коррект. стоимости материала',
    width: 90,
    editable: true,
    FormItem: <CorrectMaterialCost />,
    fieldDescriptors: [
        {
            name: 'correctMaterialCost',
            getValue: (record: CalculationPosition) => {
                const uniqueMaterials = getUniqueMaterials(record)

                // Идем по актуальному списку уникальных материалов
                const correctMaterialCost = uniqueMaterials.map(m => {
                    const correct = record.correctMaterialCost?.find(
                        c => c.material_type?.documentId === m.documentId
                    )

                    if (correct) {
                        // Если для материала уже есть корректировка
                        return {
                            id: correct.id,
                            material_type: { connect: [m.documentId] },
                            cost: correct.cost,
                        }
                    } else {
                        // Если нет
                        return {
                            material_type: { connect: [m.documentId] },
                        }
                    }
                })

                return correctMaterialCost
            },
        },
    ],
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => <CorrectMaterialCostNames data={r} />),
}
